import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Input } from "../Elements";
import GroupTitle from "./GroupTitle";
import paymentApi from "../../../common/api/paymentApi";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../store/RootState";
import { isInputValidationError } from "../../../common/helpers/paymentHelpers";

export const commonRootUrl = "https://tahsilat.elogo.com.tr"
export type CardInfoType = {
    cardNumber: string,
    expireDate: string,
    cvc: string,
    cardHolderName: string
}

export type CardInformationRef = {
    getCardBin: () => string,
    getCardInformations: () => CardInfoType
}
type Props = {
    licenseKey: string,
    taxCode: string,
    selectInstallmentList: () => void
}
const initialBrandInformations = {
    type: "",
    id: 0,
    image: "",
    name: "",
    visa_MC_AmEx: ""
}
const CardInformationArea = React.forwardRef<CardInformationRef, Props>((props: Props, ref) => {

    useImperativeHandle(ref, () => ({

        getCardBin() {
            return getCardBinNumber();
        },
        getCardInformations() {
            return cardInformation;
        }

    }));
    const { validationErrors } = useSelector((state: RootStateType) => state.paymentPage);
    const { licenseKey, taxCode, selectInstallmentList } = props;

    const [cardInformation, setCardInformation] = useState({
        cardNumber: "",
        expireDate: "",
        cvc: "",
        cardHolderName: ""
    });
    const [cardBrandInformation, setCardBrandInformation] = useState(initialBrandInformations);

    useEffect(() => {

        let cardNumber = cardInformation.cardNumber.replace(/ /g, '');

        if (cardNumber.length >=15) {
            const cardBin = cardNumber.substring(0, 8);
            getBrandInformation(cardBin);
            selectInstallmentList()
        }else {
        }
    }, [cardInformation.cardNumber]);

    function getCardBinNumber() {
        let cardBin = cardInformation.cardNumber.replace(/ /g, '').substring(0, 8);

        return cardBin;
    }

    const onChangeCardInformation = (event: any) => {
        const value = event.target.value;
        const name = event.target.name;
   
        setCardInformation({
            ...cardInformation,
            [name]: value
        });
    }

    const getBrandInformation = async (cardBin: string) => {

        const params = {
            CardNumber: cardBin
        }
        var method = "/cardbrand";
        const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
        const { data, errorMessage, isSuccess } = await paymentApi.get(method, params, apiParams);

        if (isSuccess) {
            setCardBrandInformation(data);
        }else {
            setCardBrandInformation(initialBrandInformations);
        }

    }

    const getVisaAmexLogo = () => {
        if (cardBrandInformation.visa_MC_AmEx == "Visa") {

            return (
                <div className="mr-1 mt-0.5">
                    <span
                        className="FormFieldInput-IconsIcon is-visible">
                        <img
                            src="/images/visa.svg"
                            alt="Visa"
                            className="BrandIcon max-h-[20px]"
                            loading="lazy" /></span>
                </div>
            );
        } else if (cardBrandInformation.visa_MC_AmEx == "MasterCard") {

            return (
                <div className="mr-1 mt-0.5">
                    <span
                        className="FormFieldInput-IconsIcon is-visible"><img
                            src="/images/mastercard.svg"
                            alt="MasterCard"
                            className="BrandIcon"
                            loading="lazy" /></span>
                </div>
            );
        }
        else if (cardBrandInformation.visa_MC_AmEx.toLowerCase() == "troy") {

            return (
                <div className="mr-1 mt-0.5">
                    <span
                        className="FormFieldInput-IconsIcon is-visible"><img
                            src="/images/troy-yeni.png"
                            alt="Troy"
                            className="BrandIcon"
                            loading="lazy" /></span>
                </div>
            );
        }
        return null;
    }


    return (
        <div className="w-full bg-white mt-6 ">
            <GroupTitle title="Kart Bilgileri" />
            <div className="">
                <Input
                    label=""
                    className="w-full bg-white mt-4 resize-none rounded-lg border border-gray-200 justify-start "
                    name="cardHolderName"
                    onChange={onChangeCardInformation}
                    required
                    placeholder="Kart Üzerindeki İsim"
                    type="text"
                    error={isInputValidationError("cardHolderName", validationErrors) && !cardInformation.cardHolderName}
                />

                <div className=" mt-3 relative">

                    <Input
                        label=""
                        className="w-full bg-white resize-none !rounded-t-lg !rounded-b-none  border border-gray-200 justify-start border-b-0 focus:border-b "
                        name="cardNumber"
                        required
                        mask="9999 9999 9999 9999"
                        placeholder="**** **** **** ****"
                        type="text"
                        onChange={onChangeCardInformation}
                        rightIconClass="!top-0.5"
                        error={isInputValidationError("cardNumber", validationErrors) && !cardInformation.cardNumber}
                        rightIcon={
                            cardBrandInformation.image?.length > 0 ? (
                                <div className="flex items-center">
                                    {getVisaAmexLogo()}
                                <span className="FormFieldInput-IconsIcon is-visible">
                                    <img
                                        src={commonRootUrl + cardBrandInformation.image}
                                        alt="MasterCard"
                                        className=""
                                        height={"20"}
                                        style={{
                                            height: 30
                                        }}
                                        loading="lazy"
                                    />
                                    </span>
                                    </div>
                            ) : null
                        }
                    />

                    <div className="flex items-center">
                        <Input
                            label=""
                            className="w-full bg-white resize-none !rounded-b-lg !rounded-br-none !rounded-t-none border border-gray-200 justify-start border-r-0 focus:border-r "
                            name="expireDate"
                            required
                            placeholder="AA/YY"
                            mask="99 / 99"
                            type="text"
                            containerClassName={"w-full"}
                            onChange={onChangeCardInformation}
                            error={isInputValidationError("expireDate", validationErrors) && !cardInformation.expireDate}
                        />
                        <Input
                            label=""
                            className="w-full bg-white resize-none !rounded-b-lg !rounded-bl-none !rounded-t-none border border-gray-200 justify-start "
                            name="cvc"
                            required
                            placeholder="CVC"
                            type="text"
                            containerClassName={"w-full"}
                            onChange={onChangeCardInformation}
                            mask="9999"
                            error={isInputValidationError("cvc", validationErrors) && !cardInformation.cvc}

                        />
                    </div>
                </div>
            </div>
        </div>
    );
})
export default CardInformationArea;